import { toSafeString } from '@shared/utils';

const resolveDefaultMemberRoleOption = (roleOptions = []) => {
  const safeRoleOptions = Array.isArray(roleOptions) ? roleOptions : [];
  const explicitMemberRole = safeRoleOptions.find((role) => toSafeString(role?.name).toLowerCase() === 'member');

  if (explicitMemberRole) {
    return explicitMemberRole;
  }

  return safeRoleOptions[0] || null;
};

export default resolveDefaultMemberRoleOption;
